import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppService } from './app.service';
import { StorageService } from './storage.service';
import { HttpClient } from '@angular/common/http';

export interface EndpointGroup {
  ttsEndpoint: string;
  tts2022PremEndpoint: string;
  tts2022PlusEndpoint: string;
  iosTtsEndpoint: string;
  androidTtsEndpoint: string;
  iosTtsPremEndpoint: string;
  iosTtsPlusEndpoint: string;
  androidTtsPremEndpoint: string;
  androidTtsPlusEndpoint: string;
  convertEndpoint: string;
  pwAudioManagement: string;
  iOSAudioManagement: string;
  pwUserInfo: string;
  paymentEndpoint: string;
  billEndpoint: string;
  mobileEndpoint: string;
  webApiDomain: string;
  eduEndpoint: string;
  ssoApi: string;
  issueApi: string;
  chromeExtensionId: string;
  appCheckVersionEndpoint: string;
  uploadOcrDomain: string;
  pdfTaggingEndpoint: string;
}

@Injectable({
  providedIn: 'root'
})

export class EndpointService {

  envEndpoints: EndpointGroup = {
    ttsEndpoint: '',
    tts2022PremEndpoint: '',
    tts2022PlusEndpoint: '',
    iosTtsEndpoint: '',
    androidTtsEndpoint: '',
    iosTtsPremEndpoint: '',
    iosTtsPlusEndpoint: '',
    androidTtsPremEndpoint: '',
    androidTtsPlusEndpoint: '',
    convertEndpoint: '',
    pwAudioManagement: '',
    iOSAudioManagement: '',
    pwUserInfo: '',
    paymentEndpoint: '',
    billEndpoint: '',
    mobileEndpoint: '',
    webApiDomain: '',
    eduEndpoint: '',
    ssoApi: '',
    issueApi: '',
    chromeExtensionId: '',
    appCheckVersionEndpoint: '',
    uploadOcrDomain: '',
    pdfTaggingEndpoint: ''
  };

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
  ) {

  }

  public init() {
    // TODO
    return Promise.resolve(null);

  }

  public setLatestTTSEndpoint(appversion) {
    return this.getLatestEndpoint(appversion)
      .then(res => {
        // alert(res);
        return this.saveLatestEndpointsInLocalStorage(res);
      },
        err => {
          return Promise.resolve(null);
        })
      .then(() => {
        return this.clearEndpoints();
      })
      .then(() => {
        return this.resetEndpoints();
      });
  }

  private clearEndpoints() {
    this.envEndpoints = {
      ttsEndpoint: '',
      tts2022PremEndpoint: '',
      tts2022PlusEndpoint: '',
      iosTtsEndpoint: '',
      androidTtsEndpoint: '',
      iosTtsPremEndpoint: '',
      iosTtsPlusEndpoint: '',
      androidTtsPremEndpoint: '',
      androidTtsPlusEndpoint: '',
      convertEndpoint: '',
      pwAudioManagement: '',
      iOSAudioManagement: '',
      pwUserInfo: '',
      paymentEndpoint: '',
      billEndpoint: '',
      mobileEndpoint: '',
      webApiDomain: '',
      eduEndpoint: '',
      ssoApi: '',
      issueApi: '',
      chromeExtensionId: '',
      appCheckVersionEndpoint: '',
      uploadOcrDomain: '',
      pdfTaggingEndpoint: ''
    }
    return Promise.resolve(null);
  }

  private resetEndpoints() {
    console.log('resetEndpoints', this.envEndpoints);
    for (let key in this.envEndpoints) {
      this.envEndpoints[key] = this.getEndpoint(key);
      console.log(key, this.envEndpoints[key]);
      // console.log(`${this.envEndpoints[edp]}`);
    }
    return Promise.resolve(null);
  }

  private getEndpoint(endpointName: string) {
    let specificEndpoint = environment[endpointName];
    if (AppService.isIOS() || AppService.isAndroid()) {
      let endpoints = this.storageService.read('NAPersonal-endpoints');
      if (endpoints) {
        if (typeof (endpoints) === 'string') {
          if (AppService.isIOS()) {
            if (endpointName === 'iosTtsEndpoint') {
              specificEndpoint = endpoints;
            }
          } else if (AppService.isAndroid()) {
            if (endpointName === 'androidTtsEndpoint') {
              specificEndpoint = endpoints;
            }
          }
        } else if (typeof (endpoints) === 'object' && endpoints[endpointName]) {
          specificEndpoint = endpoints[endpointName];
        }
      }
    }
    return specificEndpoint;
  }

  private getLatestEndpoint = (appversion): Promise<String> => {

    let params = null;
    if (AppService.isIOS()) {
      params = {
        version: appversion,
        app: 'ios'
      };
    } else if (AppService.isAndroid()) {
      params = {
        version: appversion,
        app: 'android'
      };
    }
    if (!environment.production) {
      params['stage'] = 'test';
    }
    const headers = {
      'Content-Type': 'application/json'
    };

    const url = this.getEndpoint('appCheckVersionEndpoint') + '/ttsurl';

    const options = { headers: headers, params: params };
    return new Promise((resolve, reject) => {
      this.http.get(url, options).toPromise()
        .then(response => {
          console.log('response', response);
          resolve(response['tts']);
        })
        .catch(error => {
          console.error('err ', error);
          reject(error);
        });
    });

  }

  private saveLatestEndpointsInLocalStorage(response) {
    if (response) {
      if (AppService.isIOS() || AppService.isAndroid()) {
        let endpoints = response;
        this.storageService.write('NAPersonal-endpoints', endpoints);
      }
    }
    return Promise.resolve(null);
  }
}
